<template>
  <core-modal
    @close="closeModal"
    :stateOpen="isOpen"
    containerStyle="width: 40%"
  >
    <div slot="header" class="p-3 text-uppercase">
      {{ $t('reservation.cancel-all') }}
    </div>
    <div slot="body">
      {{ $t('reservation.cancel-question') }}
    </div>
    <div slot="footer">
      <button
        type="button"
        @click="cancelAll"
        class="btn btn-primary rounded m-0"
      >
        {{ $t('general.cancel') }}
      </button>
    </div>
  </core-modal>
</template>

<script>

export default {
  props: {
    isOpen: {
      default: false,
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeModal () {
      this.$emit('closeModal')
    },
    cancelAll () {
      this.$emit('cancelAll')
      this.$emit('closeModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/CancelModal.vue